import * as React from 'react';
import { History } from 'history';
import Model from './product-model';
import BasePicklistCard from '../base/base-picklistcard.component';
import AppService from '../../services/app.service';

interface IProps { 
  history: History;
  caption?: string;
  producttypeType?: string;
  currentId?: number;
  pricetype?: string;
  productgroupId?: number;
  pageSize?: number;
  cardCount?: number;
  swipe?: string;
  onLoad?: (data: any) => void;  
  onChangeSwipe?: (value: string) => void;
  disableSearch?: boolean;
}

interface IState {
}

export default class ProductPicklistCard extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  private header: any = Model.columnPicklistCard.filter((d: any) => d.name !== (this.props.pricetype === 'pricebase'? 'pricesale' : 'pricebase'));

  private onLoad = (data: any) => {
    this.props.onLoad?.(data);
    this.props.history.location.state = AppService.historyState('productgroupId', this.props.productgroupId);
  }

  private onChangeSwipe = (value: string) => {
    this.props.onChangeSwipe?.(value);
  }

  public render(): React.ReactNode {
    return (
      <BasePicklistCard history={this.props.history} id={this.props.productgroupId} caption={this.props.caption} endPointFilter={Model.endPointFilter(undefined, this.props.producttypeType, this.props.productgroupId || AppService.historyState()?.productgroupId, 'active')} model={Model} currentId={this.props.currentId} onLoad={this.onLoad} header={this.header} pageSize={this.props.pageSize} searchField={this.props.disableSearch? ' ' : ''} cardCount={this.props.cardCount} swipe={this.props.swipe} onChangeSwipe={this.onChangeSwipe} autoLoad disableBackButton disableCard/>
    );
  }
}
